/**
 * @module
 * @format
 */

import {guard, INTERFACE, IS_INPUT} from '@acng/frontend-rubicon';
import {post} from 'acng/core/service/backend.js';
import {popup} from '@acng/frontend-discovery';
import {FormController} from 'nova';

import {t} from '../../locale/config/translate.js';
import {getLocalOverlay} from '../../core/service/overlay.js';
import {user} from '../user.js';

class UserRename extends FormController {
  /**
   * @param {HTMLFormElement} form
   * @param {FormData} data
   *
   * @returns {Promise<void>}
   */
  async submit(form, data) {
    await post('user/rename', data, form);
    // @ts-ignore
    user.nickname = data.get('nickname');
    await popup(form).info(await t('userPool.nicknameChanged'));
    getLocalOverlay(form)?.close();
  }

  /**
   * @param {HTMLFormElement} form
   *
   * @returns {void}
   */
  arrange(form) {
    ASSERT: {
      guard(form.elements, INTERFACE({nickname: IS_INPUT}));
    }

    const {nickname} = form.elements;
    nickname.type = 'text';
    nickname.required = true;
  }
}

export {UserRename};
